import React, { useState } from "react";
import "./CustomBookmark.css";
import { Tooltip } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBookmark } from "@fortawesome/pro-regular-svg-icons";
import { faBookmark as faBookmarkOnHover } from "@fortawesome/pro-solid-svg-icons";
import { PublicPortalTheme } from "@publicPortal/theme/MuiPublicPortal.module";

interface BookmarkProps {
    action: () => void;
    tooltipMessage: string;
    userId: number | undefined;
}

const SaveBookmark: React.FC<BookmarkProps> = (props) => {
    const [isHover, setIsHover] = useState(false);

    if (props.userId) {
        return (
            <Tooltip title={props.tooltipMessage}>
                <IconButton className="custom-bookmark-button" onClick={props.action} onMouseOver={() => setIsHover(true)} onMouseLeave={() => setIsHover(false)}>
                    {getRegularIcon()}
                </IconButton>
            </Tooltip>
        );
    } else {
        return null;
    }

    function getRegularIcon() {
        const color = PublicPortalTheme.palette.primary.main;
        if (isHover) {
            return <FontAwesomeIcon icon={faBookmarkOnHover} color={color} style={PublicPortalTheme.icons.sizeL} />;
        } else {
            return <FontAwesomeIcon icon={faBookmark} color={color} style={PublicPortalTheme.icons.sizeL} />;
        }
    }
};

export default SaveBookmark;
export type { BookmarkProps };
